module.exports = __webpack_public_path__ + "static/img/KG.d786536b.svg";